"use client";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import {
  MediaPlayer,
  MediaProvider,
  PlayButton,
  Poster,
  Track,
} from "@vidstack/react";
import {
  defaultLayoutIcons,
  DefaultVideoLayout,
} from "@vidstack/react/player/layouts/default";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog-transparent";
import Image from "next/image";
import { VideoLayout } from "./vidstack/layouts/video-layout";
import posthog from "posthog-js";

interface ImagePlayProps {
  name: string;
  image: string;
  video: string;
  width: number;
  height: number;
  className?: string;
}

export default function ImagePlay({
  name,
  image,
  video,
  width,
  height,
  className = "",
}: ImagePlayProps) {
  const track = {
    src: `${image.replace("/image.png", "/chapters.vtt")}`,
    kind: "chapters",
    language: "en-US",
    default: true,
  } as const;
  return (
    <Dialog>
      <DialogTrigger
        asChild
        className="cursor-pointer"
        onClick={() => {
          posthog.capture("project_video", { project: name, type: "Video" });
        }}
      >
        <Image
          src={image}
          alt={name}
          width={500}
          height={500}
          data-blobity-tooltip={"Play video"}
          className={className}
        />
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle></DialogTitle>
          <DialogDescription></DialogDescription>
        </DialogHeader>
        <div className="xl:first-letter:  w-[350px] sm:w-[540px] md:w-[600px] lg:w-[1000px] 2xl:w-[1400px]">
          <MediaPlayer title={name} src={video} muted={true} autoplay={true}>
            <MediaProvider>
              <Poster className="vds-poster" src={image} alt={name} />
              <Track {...track} key={track.src} /> {/* add validation? */}
            </MediaProvider>
            <DefaultVideoLayout icons={defaultLayoutIcons} />
            {/* <VideoLayout /> */}
          </MediaPlayer>
        </div>
      </DialogContent>
    </Dialog>
  );
}
